<template>
  <div class="exit">
	  	<svg width="134" height="111" viewBox="0 0 134 111" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="20.7107" cy="20.7107" r="20.7107" fill="#DC4E4E"/>
			<circle cx="110.672" cy="99.67" r="8.4137" fill="#F0F0F0"/>
			<g>
				<path d="M90.9141 71.7946C90.2344 71.7946 89.6836 72.3454 89.6836 73.0251V87.1463C89.6836 87.8637 89.1013 88.4476 88.3857 88.4476H64.7656C64.0859 88.4476 63.5352 88.9984 63.5352 89.6781C63.5352 90.3578 64.0859 90.9086 64.7656 90.9086H88.3857C90.4583 90.9086 92.1445 89.2208 92.1445 87.1463V73.0251C92.1445 72.3454 91.5936 71.7946 90.9141 71.7946Z" fill="#3B3B3B"/>
				<path d="M42.9893 62.9534H78.1557C78.8354 62.9534 79.3862 62.4027 79.3862 61.723C79.3862 61.0433 78.8354 60.4925 78.1557 60.4925H42.9893C42.3095 60.4925 41.7588 61.0433 41.7588 61.723C41.7588 62.4027 42.3095 62.9534 42.9893 62.9534Z" fill="#3B3B3B"/>
				<path d="M42.9893 70.3665H78.1557C78.8354 70.3665 79.3862 69.8157 79.3862 69.136C79.3862 68.4563 78.8354 67.9055 78.1557 67.9055H42.9893C42.3095 67.9055 41.7588 68.4563 41.7588 69.136C41.7588 69.8155 42.3095 70.3665 42.9893 70.3665Z" fill="#3B3B3B"/>
				<path d="M61.5511 75.319H42.9893C42.3095 75.319 41.7588 75.8698 41.7588 76.5495C41.7588 77.2292 42.3095 77.7799 42.9893 77.7799H61.5513C62.231 77.7799 62.7818 77.2292 62.7818 76.5495C62.7816 75.8699 62.2308 75.319 61.5511 75.319Z" fill="#3B3B3B"/>
				<path d="M31.0508 42.4725H53.2812C53.961 42.4725 54.5117 41.9216 54.5117 41.2421C54.5117 40.5624 53.961 40.0116 53.2812 40.0116H31.4609V31.0786H63.1494V40.0116H59.1875C58.5078 40.0116 57.957 40.5624 57.957 41.2421C57.957 41.9216 58.5078 42.4725 59.1875 42.4725H63.5596C64.6905 42.4725 65.6104 41.5525 65.6104 40.4217V30.6684C65.6104 29.5377 64.6905 28.6176 63.5596 28.6176H31.0508C29.9199 28.6176 29 29.5377 29 30.6684V40.4217C29 41.5526 29.9199 42.4725 31.0508 42.4725Z" fill="#3B3B3B"/>
				<path d="M58.8197 35.5448C58.8197 34.8651 58.2689 34.3144 57.5892 34.3144H35.9722C35.2925 34.3144 34.7417 34.8651 34.7417 35.5448C34.7417 36.2245 35.2925 36.7753 35.9722 36.7753H57.5892C58.2688 36.7753 58.8197 36.2244 58.8197 35.5448Z" fill="#3B3B3B"/>
				<path d="M94.6552 25.7966C84.5396 25.7966 76.31 34.0263 76.31 44.1417C76.31 45.1758 76.3975 46.1895 76.5627 47.1775H32.7587C30.6861 47.1775 29 48.8656 29 50.94V87.1463C29 89.2208 30.6861 90.9085 32.7587 90.9085H39.8285V99.6692C39.8285 101.294 40.6338 101.87 41.1139 102.068C41.2624 102.129 41.5053 102.203 41.8157 102.203C42.3133 102.203 42.9845 102.014 43.7172 101.28L54.0755 90.9084H59.0233C59.703 90.9084 60.2537 90.3576 60.2537 89.6779C60.2537 88.9982 59.703 88.4474 59.0233 88.4474H53.5652C53.2386 88.4474 52.9254 88.5772 52.6946 88.8085L42.2892 99.2272V89.6779C42.2892 88.9982 41.7385 88.4474 41.0588 88.4474H32.7587C32.0432 88.4474 31.4609 87.8635 31.4609 87.1461V50.94C31.4609 50.2222 32.0432 49.6383 32.7587 49.6383H77.1515C79.001 55.5147 83.7337 60.1245 89.6836 61.8017V67.2827C89.6836 67.9624 90.2344 68.5132 90.9141 68.5132C91.5938 68.5132 92.1445 67.9624 92.1445 67.2827V62.3141C92.9657 62.427 93.8034 62.4868 94.6552 62.4868C104.77 62.4868 113 54.2571 113 44.1417C113 34.0263 104.77 25.7966 94.6552 25.7966ZM94.6552 60.0259C85.8965 60.0259 78.771 52.9 78.771 44.1417C78.771 35.3829 85.8967 28.2575 94.6552 28.2575C103.414 28.2575 110.539 35.3831 110.539 44.1417C110.539 52.9002 103.413 60.0259 94.6552 60.0259Z" fill="#3B3B3B"/>
				<path d="M87.9857 50.4282C87.5032 50.9067 87.4998 51.686 87.978 52.1685C88.4564 52.651 89.2354 52.6546 89.7182 52.1762C92.4404 49.4778 96.8694 49.4778 99.5915 52.1762C99.8315 52.4139 100.145 52.5328 100.458 52.5328C100.775 52.5328 101.091 52.4111 101.332 52.1685C101.81 51.686 101.807 50.9067 101.324 50.4282C97.6465 46.7834 91.6634 46.7834 87.9857 50.4282Z" fill="#3B3B3B"/>
				<path d="M91.7745 42.708C91.7745 43.3877 91.2237 43.9384 90.544 43.9384C89.8643 43.9384 89.3135 43.3877 89.3135 42.708C89.3135 41.7896 88.5485 41.0421 87.6079 41.0421C86.6674 41.0421 85.9023 41.7897 85.9023 42.708C85.9023 43.3877 85.3516 43.9384 84.6719 43.9384C83.9922 43.9384 83.4414 43.3877 83.4414 42.708C83.4414 40.4326 85.3106 38.5811 87.6079 38.5811C89.9053 38.581 91.7745 40.4324 91.7745 42.708Z" fill="#3B3B3B"/>
				<path d="M104.638 43.9384C103.958 43.9384 103.408 43.3877 103.408 42.708C103.408 41.7896 102.642 41.0421 101.702 41.0421C100.761 41.0421 99.9961 41.7897 99.9961 42.708C99.9961 43.3877 99.4453 43.9384 98.7656 43.9384C98.0859 43.9384 97.5352 43.3877 97.5352 42.708C97.5352 40.4326 99.4045 38.5811 101.702 38.5811C103.999 38.5811 105.869 40.4326 105.869 42.708C105.869 43.3875 105.318 43.9384 104.638 43.9384Z" fill="#3B3B3B"/>
			</g>
		</svg>
		<h3>
			{{$ml.get(`We will miss you`)}}
		</h3>
		<p>
			{{$ml.get(`Thank you for your feedback`)}}
		</p>

		<div class="feed-buttons">
			<app-btn styling="outline" @click.stop="exit()">
				{{ $ml.get('EXIT') }}
			</app-btn>
		</div>
  </div>
</template>

<script>
export default {
	methods: {
		exit () {
			this.$store.commit('user/logout');
			this.$router.push({ path: '/' });
			location.reload();
		},
	}
}
</script>

<style lang="scss" scoped>
.exit {
	display: flex;
	flex-direction: column;
	align-items: center;

	> p {
		max-width: 450px;
		font-size: 14px;
		font-family: Roboto;
		color: #666666;
		text-align: center;
		margin: 0 170px;
		margin-bottom: 40px;
	}

	.feed-buttons {
		display: flex;
		justify-content: center;

		button {
			margin: 0 10px;
			margin-bottom: 20px;
		}
	}
}
</style>